<template>
  <div class="page-comp-customer-contact">
    <div class="details-card-top">
      <span>{{ $t('客户关键联系人') }}</span>
      <template v-if="userInfo?.roles?.indexOf('afterSale:addContacter') !== -1 && buttons?.indexOf('afterSale:addContacter') > -1 && data.permission == 1">
        <jw-link @click="addEditContract(1)">{{ $t('添加联系人') }}</jw-link>
      </template>
    </div>
    <div class="contract-content" v-if="data.contractList.length > 0">
      <div v-for="item in data.contractList" :key="item.id" class="contract-content-item">
        <jw-space direction="vertical">
          <jw-descriptions :data="item.list" :title="item.name" layout="inline-horizontal" table-layout="fixed">
            <jw-descriptions-item v-for="(v, index) of item.list" :key="index">
              <div class="contract-content-item-container">
                <div class="contract-content-item-container-label">{{ v.label }}</div>
                <div class="contract-content-item-container-value">{{ v.value }}</div>
              </div>
            </jw-descriptions-item>
          </jw-descriptions>
          <div class="contract-content-item-title" v-if="data.permission == 1">
            <jw-space>
              <jw-button v-if="userInfo?.roles?.indexOf('afterSale:editContacter') !== -1 && buttons?.indexOf('afterSale:editContacter') > -1" size="mini" @click="addEditContract(2, item)">
                <template #icon>
                  <icon-edit />
                </template>
                {{ $t('修改') }}
              </jw-button>
              <jw-button v-if="userInfo?.roles?.indexOf('afterSale:delContacter') !== -1 && buttons?.indexOf('afterSale:delContacter') > -1" size="mini" @click="deleteContracts(item)">
                <template #icon>
                  <icon-delete />
                </template>
                {{ $t('删除') }}
              </jw-button>
            </jw-space>
          </div>
        </jw-space>
      </div>
    </div>
    <div v-else class="contract-content-empty">
      <jw-empty />
    </div>
    <update-contract ref="updateContractRef" @cb="getContractList"></update-contract>
  </div>
</template>

<script setup>
import { reactive, inject, ref, onMounted } from 'vue';
import { Message, Modal } from '@arco-design/web-vue';
import { salesService, layoutService } from '@/api/';
import UpdateContract from '@/views/sales-service/components/update-contract/index.vue';
import { useUserStore } from '@/store';
import { useI18n } from 'vue-i18n';
const { userInfo } = useUserStore(); //用户信息
const data = reactive({
  id: inject('detailParams')?.id,
  permission: inject('detailParams')?.permission,
  contractList: [],
  entity: inject('detailParams')?.entity,
  selectOption: {}
});
const updateContractRef = ref();
const { t } = useI18n();
onMounted(() => {
  getContractList();
  getDetail();
});
const props = defineProps({
  moduleId: {
    type: String,
    default: ''
  }
});
const buttons = ref([]);
const getDetail = async () => {
  if (!props?.moduleId) {
    return false;
  }
  try {
    const params = {
      entity: data.entity,
      moduleId: props.moduleId,
      businessId: data.id,
      apiIndex: props.moduleId
    };
    const json = await layoutService.getDetail(params);
    if (!json.error) {
      const _buttons = [];
      json?.result?.map((b) => {
        _buttons.push(b.value);
      });
      buttons.value = _buttons;
    }
  } catch (e) {
    console.log(e);
  }
};
// 获取关键联人列表getContractList
const getContractList = async () => {
  try {
    const params = {
      salesId: data.id
    };
    const json = await salesService.getContractList(params);
    if (!json.error) {
      console.log(53, json.result);
      // 向data.contractList中赋值格式为label,value
      const list = json.result.map((item) => {
        return {
          name: item.name,
          id: item.id,
          recordId: item.recordId,
          salesId: item.salesId,
          list: [
            { label: t('对接产品线') + ':', valueName: item?.productLine || null, value: item?.productLineName || '-', fieldKey: 'productLine' },
            { label: t('对接人角色') + ':', valueName: item?.role || null, value: item?.roleName || '-', fieldKey: 'role' },
            { label: t('对接人职位') + ':', valueName: item?.posts || null, value: item?.postsName || '-', fieldKey: 'posts' },
            { label: t('所在部门') + ':', valueName: item?.dept || null, value: item?.deptName || '-', fieldKey: 'dept' },
            { label: t('对接人态度') + ':', valueName: item?.attitude || null, value: item?.attitudeName || '-', fieldKey: 'attitude' },
            { label: t('联系方式') + ':', valueName: item?.phone || null, value: item?.phone || '-', fieldKey: 'phone' },
            { label: t('补充信息') + ':', valueName: item?.remark || null, value: item?.remark || '-', fieldKey: 'remark' }
          ]
        };
      });
      data.contractList = list;
      console.log(55, list, data.contractList);
      getSelectOption();
    } else {
      Message.error(json.error?.msg || t('获取数据失败'));
    }
  } catch (e) {
    console.log(e);
    Message.error(e.message || e.statusText || t('获取数据失败'));
  }
};
const addEditContract = (type, record) => {
  console.log('添加或者编辑联系人', type, record);
  const params = {
    title: t('添加客户关键联系人'),
    type,
    salesId: data.id,
    selectOption: data.selectOption
  };
  if (type === 2) {
    params.title = t('编辑客户关键联系人');
    params['record'] = record;
  }
  updateContractRef.value.open(params);
};
// 删除联系人
const deleteContracts = (record) => {
  console.log('移除角色调移除接口', record);
  Modal.confirm({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: t('删除该联系人') + '？',
    content: `${t('请确认是否删除')}【${record.name}】${t('这条客户关键联系人')}？`,
    onOk: () => {
      deleteContract(record.id);
    }
  });
};
// 删除接口
const deleteContract = async (id) => {
  try {
    const json = await salesService.deleteContract({ id });
    if (!json.error) {
      Message.success(t('操作成功'));
      getContractList();
    } else {
      Message.error(json.error?.msg || t('操作失败'));
    }
  } catch (e) {
    Message.error(e.message || e.statusText || t('操作失败'));
  }
};
// 获取新增/编辑时所有的下拉选项值
const getSelectOption = async () => {
  data.selectOption = {};
  try {
    const json = await salesService.getSelectOption();
    if (!json.error) {
      console.log(53, json.result);
      data.selectOption = json.result;
    } else {
      Message.error(json.error?.msg || t('获取数据失败'));
    }
  } catch (e) {
    console.log(e);
    Message.error(e.message || e.statusText || t('获取数据失败'));
  }
};
defineExpose({ getContractList });
</script>
<style scoped lang="less">
@import './index.less';
</style>
